import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-[#f8f7f2]">
      <div className="max-w-6xl mx-auto px-8 md:px-14">
        <div className="flex flex-col items-center text-center">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-8 bg-[#c8a84b]" />
              <span
                className="text-[#c8a84b] text-xs font-bold tracking-[0.3em] uppercase"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Let&apos;s Get Started
              </span>
              <div className="h-px w-8 bg-[#c8a84b]" />
            </div>

            <h2
              className="text-4xl md:text-5xl font-extrabold text-[#1a3a3a] leading-tight mb-6 max-w-2xl"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Ready to Build{' '}
              <em className="not-italic text-[#c8a84b]">Your Team?</em>
            </h2>

            <p
              className="text-[#1a3a3a]/60 text-base leading-relaxed mb-10 max-w-xl"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Whether you need one person or many, we&apos;re here to help. Reach out today and receive qualified candidates fast.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="px-8 py-3.5 rounded-md bg-[#1a3a3a] text-white font-bold text-sm tracking-wide hover:bg-[#0d2020] transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Contact Us Today
              </Link>
              <Link
                to="/services"
                className="px-8 py-3.5 rounded-md border text-[#1a3a3a] font-semibold text-sm tracking-wide transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
                style={{ borderColor: 'rgba(26,58,58,0.25)' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(26,58,58,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                View Services
              </Link>
            </div>

            {/* Trust badges */}
            <div className="mt-12 pt-10 border-t border-[#1a3a3a]/10 grid grid-cols-2 md:grid-cols-4 gap-6 w-full max-w-2xl">
              {[
                { icon: 'ri-shield-check-line', label: 'Background Checked' },
                { icon: 'ri-time-line', label: 'Fast Placement' },
                { icon: 'ri-customer-service-2-line', label: 'Dedicated Support' },
                { icon: 'ri-medal-line', label: 'Quality Guaranteed' },
              ].map((badge) => (
                <div key={badge.label} className="flex flex-col items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#c8a84b]/15 border border-[#c8a84b]/30">
                    <i className={`${badge.icon} text-[#c8a84b] text-base`} />
                  </div>
                  <span
                    className="text-[#1a3a3a]/55 text-xs font-medium text-center"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {badge.label}
                  </span>
                </div>
              ))}
            </div>
        </div>
      </div>
    </section>
  );
}
